import { Route, Routes } from "react-router-dom";
import React from "react";
import Homeone from '../components/Home/Homeone/Main'
import Hometwo from '../components/Home/Hometwo/Main'
import HomeThree from '../components/Home/HomeThree/Main'
import Homefore from '../components/Home/Homefour/Main'
import Homefive from '../components/Home/HomeFive/Main'
import Homesix from '../components/Home/HomeSix/Main'
import Homeseven from '../components/Home/Homeseven/Main'
import Shop from '../components//Shop/Shop/Main'
import Sidebar1 from '../components/Shop/shop-filter/Main'
import Sidebar2 from '../components/Shop/shop-filter2/Main'
import ShopDetails from '../components/Shop/Shopdetails/Main'
import Blog from '../components/Blogsection/Blog/Main'
import BlogDetails from '../components/Blogsection/BlogDetails/Main'
import Aboutus from '../components/Pages/Aboutus/Main'
import Affilate from '../components/Pages/Affilate/Main'
import Career from '../components/Pages/Career/Main'
import Faq from "../components/Pages/Faq/Main";
import Error from "../components/Pages/Error/Main";
import Contact from "../components/Pages/Contactus/Main";
import Team from '../components/Team/Main'
import TeamDetails from '../components/TeamDetails/Main'
import Privace$Policy from '../components/Privace&Policy/Main'
import Cart from '../components/Cart/Main'
import Wishlist from '../components/Wishlist/Main'
import Checkout from '../components/Checkout/Main'
import Portfolio from '../components/Portfolio/Main'

const index = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homeone />}></Route>
        <Route path="/Hometwo" element={<Hometwo />}></Route>
        <Route path="/HomeThree" element={<HomeThree />}></Route>
        <Route path="/Homefour" element={<Homefore />}></Route>
        <Route path="/Homefive" element={<Homefive />}></Route>
        <Route path="/Homesix" element={<Homesix />}></Route>
        <Route path="/Homeseven" element={<Homeseven />}></Route>
        <Route path="/Shop" element={<Shop />}></Route>
        <Route path="/shop-filter" element={<Sidebar1 />}></Route>
        <Route path="/shop-filter2" element={<Sidebar2 />}></Route>
        <Route path="/ShopDetails" element={<ShopDetails />}></Route>
        <Route path='/Blog' element={<Blog />}></Route>
        <Route path="/BlogDetails" element={<BlogDetails />}></Route>
        <Route path='/Aboutus' element={<Aboutus />}></Route>
        <Route path="/Affiliate" element={<Affilate />}></Route>
        <Route path="/Career" element={<Career />}></Route>
        <Route path="/Faq" element={<Faq />}></Route>
        <Route path="/Error" element={<Error />}></Route>
        <Route path="/Contactus" element={<Contact />}></Route>
        <Route path='/Team' element={<Team />}></Route>
        <Route path="/TeamDetails" element={<TeamDetails />}></Route>
        <Route path="/Privace$Policy" element={<Privace$Policy />}></Route>
        <Route path="/Cart" element={<Cart />}></Route>
        <Route path="/WishList" element={<Wishlist />}></Route>
        <Route path="/Checkout" element={<Checkout />}></Route>
        <Route path="/Portfolio" element={<Portfolio />}></Route>
      </Routes>
    </>
  )
}
export default index
